export default "__VITE_ASSET__05HJvR09HtRmI6I4z21tcw__"